/**
 * Generated by '@kontent-ai/model-generator@6.5.1'
 */
export const languages = {
    /**
     * Default project language
     */
    default: {
        codename: 'default',
        id: '00000000-0000-0000-0000-000000000000',
        isActive: true,
        isDefault: true,
        fallbackLanguageId: '00000000-0000-0000-0000-000000000000',
        externalId: undefined,
        name: 'Default project language'
    }
} as const;
